import { graphql } from "babel-plugin-relay/macro";

export const mutation = graphql`
    mutation bulkSigningCsvUrlsMutation($input: BulkSigningCsvUrlsInput!) {
        bulkSigningCsvUrls(input: $input) {
            uploadUrl
            sampleUrl
        }
    }
`;
